import React from "react";
import { Link, LinkProps } from "react-router";

import { IGIREMenuItem } from "@/router/models/router.types";

type Props = {
  item: IGIREMenuItem;
};

export const ItemLevel1 = React.forwardRef(function ItemLevel1(
  { item, ...props }: Props & Omit<LinkProps, "to">,
  ref: React.Ref<HTMLAnchorElement>,
) {
  return (
    <Link
      ref={ref}
      className="flex items-center gap-2"
      to={{ pathname: item.url?.replaceAll("/#", "") }}
      {...props}
    >
      {item.icon && (
        <span className="mr-1 inline-flex fill-urbix-gray-1000 *:h-[1.042rem] *:w-[1.042rem]">
          {item.icon}
        </span>
      )}
      <span>{item.label}</span>
    </Link>
  );
});

ItemLevel1.displayName = "ItemLevel1";
